import { qualifyUrl } from "util/URLUtils";
import fetch from 'logic/rest/FetchProvider';

import type { EmailTemplateConfig } from "./types";

export const fetchEmailTemplates = () => {
  const url = qualifyUrl('/plugins/org.graylog.plugins.customization/email_notification_defaults');

  return fetch<EmailTemplateConfig>('GET', url);
}

export const updateEmailTemplates = (config: EmailTemplateConfig): Promise<void> => {
  const url = qualifyUrl('/plugins/org.graylog.plugins.customization/email_notification_defaults');

  return fetch('POST', url, config);
}
